export default "__VITE_ASSET__bc240a45__"